// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2VJUB","inputWrap":"styles_inputWrap__M7yCA","input":"styles_input__2GavJ"};